module.exports = __webpack_public_path__ + "static/media/error.f4cda4f8.png";